<template>
    <div id="page">
        <data-table class="pages" v-blur="blur"
                    :clientPagination="false"
                    :cols="columns"
                    :dateColumns="dateColumns"
                    :url="url"
                    :orderBy="orderBy"
                    :title="title"
                    :dataPath="dataPath"
                    :requestParams="requestParams"
                    :filterableGlobal="isFilterableGlobal"
                    :isStolen="true"
                    :fullPageName="pageName"
                    @loading="onLoading"
                    @loaded="onLoaded"
                    @onStolenCheckBoxClicked="onStolenCheckBoxClicked"
                    @onStolenSelectAllClicked="onStolenSelectAllClicked"
                    @onStolenSendMailClicked="onStolenSendMailClicked"
                    :isSummaryVisible="true"
                    :isDataTableVisible="isDataTableVisible"
                    @toggleLoading="toggleLoading"
                    :summaryRequestParams="summaryRequestParams"
                    :isStixExportAvailable="false"
                    ref="stolenPasswordTable"></data-table>
        <loading-modal class="loading-modal-container" v-if="loading"></loading-modal>
    </div>
</template>

<script>

    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import DataTable from '@/components/datatable/DataTable.vue'
    import LoadingModal from '@/components/modals/LoadingModal.vue'

    export default {
        name: "stolen-passwords",
        components: {
            DataTable: DataTable,
            LoadingModal: LoadingModal
        },
        props: {
            isDirect: {
                type: Boolean,
                required: true
            },
            isClient: {
                type: Boolean,
                required: true
            },
            hidePasswordColumn: {
                type: Boolean,
                required: true
            },
            incomingThreatPageType: {
                type: Number,
                required: true
            }
        },
        mixins: [Common],
        data() {
            return {
                checkedStolenPasswords: [],
                isFilterableGlobal: true,
                dateColumns: [{column: 'leak_date', isAsc: true}, {column: 'report_date', isAsc: true}],
                loading: false
            }
        },
        methods: {
            toggleLoading(value) {
                this.loading = value;
            },
            onLoading() {
                this.loading = true;
            },
            onLoaded() {
                this.loading = false;
                var tableData = this.$refs.stolenPasswordTable.getTableData();
                for (var i = 0; i < tableData.length; i++) {
                    if (this.checkedStolenPasswords.indexOf(tableData[i].matched_credential_id) != -1) {
                        tableData[i].checked = true;
                    }
                }
            },
            onStolenCheckBoxClicked(row) {
                var index = this.checkedStolenPasswords.indexOf(row.matched_credential_id);
                if (index != -1) {
                    this.checkedStolenPasswords.splice(index, 1);
                } else {
                    this.checkedStolenPasswords.push(row.matched_credential_id);
                }
            },
            onStolenSelectAllClicked(checked, idList) {
                for (var i = 0; i < idList.length; i++) {
                    var index = this.checkedStolenPasswords.indexOf(idList[i]);
                    if (checked && index == -1) {
                        this.checkedStolenPasswords.push(idList[i]);
                    } else {
                        this.checkedStolenPasswords.splice(index, 1);
                    }
                }
            },
            onStolenSendMailClicked() {
                if (this.checkedStolenPasswords.length > 0) {
                    let log_start = Date.now();
                    let item_count = this.checkedStolenPasswords.length;
                    this.onLoading();
                    var self = this;
                    var body = {
                        idList: this.checkedStolenPasswords,
                        'is-direct': this.isDirect,
                        'is-client': this.isClient
                    };
                    var promise = self.$http.post(Constants.INTELLIGENCE_BACKEND_URL + "/stolen/send/mail", body);
                    promise.then(function (response) {
                        if (response.data.return_code == 'Unauthorized User') {
                            this.saveLog(this, this.pageName,
                                'Send Mail Clicked - ' + item_count + ' item/items (Failed due to user not has permission to send mails)',
                                this.getDurationInSeconds(log_start, Date.now()), null);
                            self.$toasted.show('User is not have permission to send mails.', {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'error'
                            });
                        } else {
                            this.saveLog(this, this.pageName,
                                'Send Mail Clicked - ' + item_count + ' item/items (Successfully completed)',
                                this.getDurationInSeconds(log_start, Date.now()), null);
                            self.$toasted.show("Mails successfully sent.", {
                                position: "bottom-center",
                                duration: 5000,
                                type: 'success'
                            });
                            self.$refs.stolenPasswordTable.refreshServerSidePage();
                            self.checkedStolenPasswords = [];
                        }
                        this.onLoaded();
                    }, function (response) {
                        this.saveLog(this, this.pageName, 'Send Mail Clicked - ' + item_count + ' item/items (Failed - Server Error)',
                            this.getDurationInSeconds(log_start, Date.now()), null);
                        self.$toasted.show('Request error, please try again.', {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                        this.onLoaded();
                    });
                } else {
                    this.$toasted.show('No rows selected.', {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            }
        },
        computed: {
            pageName() {
                if (this.isDirect) {
                    if (this.isClient) {
                        return 'Notifications - Stolen Password (Direct - Clients)'
                    } else {
                        return 'Notifications - Stolen Password (Direct - Employees)'
                    }
                } else {
                    return 'Notifications - Stolen Password (3rd Party)'
                }
            },
            columns() {
                if (this.isDirect && this.isClient) {
                    return [
                        {
                            column: "checkboxRow",
                            title: " ",
                            class: "col-5"
                        },
                        {
                            column: "displayBoth",
                            title: "Name Surname",
                            choices: ["name", "surname"],
                            class: "col-10 cell-tooltip"
                        },
                        {
                            column: "account_email",
                            title: "Account Email",
                            class: "col-10 cell-tooltip"
                        },
                        {
                            column: "employee_position",
                            title: "Employee Title",
                            class: "col-10 cell-tooltip"
                        },
                        {
                            column: "account_username",
                            title: "Username",
                            class: "col-10 col-overflow-hidden cell-tooltip"
                        },
                        {
                            column: "masked_password",
                            title: "Password",
                            class: "col-10"
                        },
                        {
                            column: "leak_date",
                            title: "First Seen Public",
                            class: "col-15 cell-tooltip"
                        },
                        {
                            column: "Platform",
                            title: "Platform",
                            class: "col-5 cell-tooltip"
                        },
                        {
                            column: "leak_found_at",
                            title: "Source",
                            class: "col-5 cell-tooltip"
                        },
                        {
                            column: "type",
                            title: "Malware",
                            class: "col-5",
                            malwareFamilyColumnName: "malwareFamilyColumnName"
                        },
                        {
                            column: "report_date",
                            title: "Report Date",
                            class: "col-10 cell-tooltip"
                        },
                        {
                            column: "notify_type",
                            title: "Flag",
                            class: "col-5"
                        }

                    ]
                } else {
                    return [
                        {
                            column: "checkboxRow",
                            title: " ",
                            class: "col-5"
                        },
                        {
                            column: "displayBoth",
                            title: "Name Surname",
                            choices: ["name", "surname"],
                            class: "col-10 cell-tooltip"
                        },
                        {
                            column: "account_email",
                            title: "Account Email",
                            class: "col-10 cell-tooltip"
                        },
                        {
                            column: "employee_position",
                            title: "Employee Title",
                            class: "col-10 cell-tooltip"
                        },
                        {
                            column: "account_username",
                            title: "Username",
                            class: "col-10 col-overflow-hidden cell-tooltip"
                        },
                        {
                            column: "eye",
                            eyeColumnName: "Password",
                            title: "Password",
                            class: "col-10"
                        },
                        {
                            column: "leak_date",
                            title: "First Seen Public",
                            class: "col-15 cell-tooltip"
                        },
                        {
                            column: "Platform",
                            title: "Platform",
                            class: "col-5 cell-tooltip"
                        },
                        {
                            column: "leak_found_at",
                            title: "Source",
                            class: "col-5 cell-tooltip"
                        },
                        {
                            column: "type",
                            title: "Malware",
                            class: "col-5",
                            malwareFamilyColumnName: "malwareFamilyColumnName"
                        },
                        {
                            column: "report_date",
                            title: "Report Date",
                            class: "col-10 cell-tooltip"
                        },
                        {
                            column: "notify_type",
                            title: "Flag",
                            class: "col-5"
                        }

                    ]
                }

            },
            url() {
                return Constants.INTELLIGENCE_BACKEND_URL + "/stolen/password/get";
            },
            orderBy() {
                return {
                    column: "id",
                    ascending: true
                }
            },
            blur() {
                return {
                    isBlurred: this.loading,
                    opacity: 0.3,
                    filter: 'blur(4px)',
                    transition: 'all .5s linear'
                }
            },
            title() {
                if (this.isDirect) {
                    if (this.isClient) {
                        return "Stolen Password [ Direct - Clients]";
                    } else {
                        return "Stolen Password [ Direct - Employees]";
                    }
                } else {
                    return "Stolen Password [ 3rd Party ]";
                }
            },
            isDataTableVisible() {
                return this.incomingThreatPageType !== Constants.ThreatPageTypes.Partner
            },
            requestParams() {
                if (this.isDirect) {
                    return {
                        "is-direct": true,
                        "is-client": this.isClient ? true : false
                    }
                } else {
                    return {
                        "is-direct": false,
                        "is-client": false
                    }
                }
            },
            dataPath() {
                return 'data.records';
            },
            summaryRequestParams() {
                if (this.incomingThreatPageType === Constants.ThreatPageTypes.Matched) {
                    if (this.isDirect) {
                        if (this.isClient) {
                            return {
                                is_partner: false,
                                threat_option: "notification",
                                feed_id: Constants.FeedEnum.STOLEN_PASSWORD_DIRECT_CLIENT,
                                showListedRow: false
                            }
                        } else {
                            return {
                                is_partner: false,
                                threat_option: "notification",
                                feed_id: Constants.FeedEnum.STOLEN_PASSWORD_EMPLOYEE,
                                showListedRow: false
                            }
                        }
                    } else {
                        return {
                            is_partner: false,
                            threat_option: "notification",
                            feed_id: Constants.FeedEnum.STOLEN_PASSWORD_3RD_PARTY,
                            showListedRow: false
                        }
                    }
                } else if (this.incomingThreatPageType === Constants.ThreatPageTypes.Partner) {
                    if (this.isDirect) {
                        if (this.isClient) {
                            return {
                                is_partner: true,
                                threat_option: "notification",
                                feed_id: Constants.FeedEnum.STOLEN_PASSWORD_DIRECT_CLIENT,
                                showListedRow: false
                            }
                        } else {
                            return {
                                is_partner: true,
                                threat_option: "notification",
                                feed_id: Constants.FeedEnum.STOLEN_PASSWORD_EMPLOYEE,
                                showListedRow: false
                            }
                        }
                    } else {
                        return {
                            is_partner: true,
                            threat_option: "notification",
                            feed_id: Constants.FeedEnum.STOLEN_PASSWORD_3RD_PARTY,
                            showListedRow: false
                        }
                    }
                }
            }

        },
        mounted() {
            // console.log("Mounted Stolen Passwords.")
        }
    }
</script>

<style scoped>

    #page {
        background-color: black;
        width: 100%;
        height: 94%;
        padding: 1.5% 1.5% 1% 1.5%;
    }

    .loading-modal-container {
        height: calc(100%);
        width: calc(100%);
        z-index: 10;
    }

</style>



// WEBPACK FOOTER //
// src/pages/StolenPasswords.vue